(function(angular){
	'use strict';
	
	var uploadObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			removeUploadCallBack: '&',
			stateObj: '<',
			uploadCallBack: '&'
		},
		controller: [UploadFunction],
		controllerAs: 'upload'
	};
	
	angular
		.module('fileUploadModule')
		.component('uploadComp', uploadObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/upload/upload.html';
	}
	
	function UploadFunction(){
		var upload = this;
		
		upload.handleUpload = function(theFile, errFiles) {
			upload.uploadCallBack({stateObject: upload.stateObj, theFile: theFile, errFiles: errFiles});
		};

		upload.handleDelete = function() {
			upload.removeUploadCallBack({stateObject: upload.stateObj});
		};
	}
})(window.angular);